var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Children } from 'react';
import { debounce } from '../lib-debounce';
import { throttle } from '../lib-throttle';
export function readTemplate(name) {
    var getNodesBySlot = function (nodes) {
        return Children.toArray(nodes).reduce(function (slotNodes, childNode) {
            if (typeof childNode !== 'object' || !('props' in childNode)) {
                return slotNodes;
            }
            if (childNode.props.slot === name) {
                return __spreadArray(__spreadArray([], slotNodes, true), [childNode], false);
            }
            return __spreadArray(__spreadArray([], slotNodes, true), getNodesBySlot(childNode.props.children), true);
        }, []);
    };
    return getNodesBySlot(this.props.children);
}
export function writeState(key, value) {
    this.setState(function (state) {
        var _a;
        // To prevent:
        // Error: Maximum update depth exceeded.
        // This can happen when a component repeatedly calls setState inside
        // componentWillUpdate or componentDidUpdate.
        // React limits the number of nested updates to prevent infinite loops.
        if (state[key] !== value) {
            return _a = {}, _a[key] = value, _a;
        }
    });
}
export function emit(name, data) {
    return this.props[name] && this.props[name](data);
}
export function cgSetTimeout(callback, timer) {
    var _this = this;
    var wrappedCallback = function () {
        callback();
        removeToCancel(_this, cancelCallback);
    };
    var cancelCallback = function () {
        clearTimeout(id);
        removeToCancel(_this, cancelCallback);
    };
    var id = setTimeout(wrappedCallback, timer);
    addToCancel(this, cancelCallback);
    return id;
}
export function cgSetInterval(callback, timer) {
    var _this = this;
    var cancelCallback = function () {
        clearInterval(id);
        removeToCancel(_this, cancelCallback);
    };
    var id = setInterval(callback, timer);
    addToCancel(this, cancelCallback);
    return id;
}
export function cgRequestAnimationFrame(callback) {
    var _this = this;
    var wrappedCallback = function () {
        callback();
        removeToCancel(_this, cancelCallback);
    };
    var cancelCallback = function () {
        cancelAnimationFrame(id);
        removeToCancel(_this, cancelCallback);
    };
    var id = requestAnimationFrame(wrappedCallback);
    addToCancel(this, cancelCallback);
    return id;
}
export function cgThrottle(callback) {
    var throttledCallback = throttle(callback);
    addToCancel(this, function () { return throttledCallback.cancel(); });
    return throttledCallback;
}
export function cgDebounce(callback, delay) {
    var debouncedCallback = debounce(callback, delay);
    addToCancel(this, function () { return debouncedCallback.cancel(); });
    return debouncedCallback;
}
export function isPropChanged(propName, prevProps) {
    return prevProps[propName] !== undefined && prevProps[propName] !== this.props[propName];
}
export function isStateChanged(propName, prevProps) {
    return prevProps[propName] !== undefined && prevProps[propName] !== this.state[propName];
}
function addToCancel(self, callback) {
    self.toCancel.push(callback);
}
function removeToCancel(self, callback) {
    var index = self.toCancel.indexOf(callback);
    if (index >= 0) {
        self.toCancel.splice(index, 1);
    }
}
export var componentApi = {
    writeState: writeState,
    emit: emit,
    readTemplate: readTemplate,
    cgSetTimeout: cgSetTimeout,
    cgSetInterval: cgSetInterval,
    cgThrottle: cgThrottle,
    cgDebounce: cgDebounce,
    cgRequestAnimationFrame: cgRequestAnimationFrame,
    isPropChanged: isPropChanged,
    isStateChanged: isStateChanged,
};
